import { render, staticRenderFns } from "./GroupCountQC.vue?vue&type=template&id=52987ad6&scoped=true"
import script from "./GroupCountQC.vue?vue&type=script&lang=js"
export * from "./GroupCountQC.vue?vue&type=script&lang=js"
import style0 from "./GroupCountQC.vue?vue&type=style&index=0&id=52987ad6&prod&scoped=true&lang=css"
import style1 from "./GroupCountQC.vue?vue&type=style&index=1&id=52987ad6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52987ad6",
  null
  
)

export default component.exports